module.exports = __webpack_public_path__ + "static/media/me.99cd3713.jpg";